.intro {
  margin: 0 4px 6px;
  color: var(--muted);
  font-size: 14px;
  line-height: 1.4;
}

.rules {
  margin: 4px 0 0;
  padding: 12px 14px 12px 30px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  background: var(--surface);
  border: 1px solid var(--card-border);
  border-radius: var(--r-md);
  color: var(--ink-soft);
  font-size: 13px;
  line-height: 1.35;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.textarea {
  width: 100%;
  box-sizing: border-box;
  padding: 12px 14px;
  background: var(--surface-sunken);
  border: 1px solid var(--card-border);
  border-radius: var(--r-md);
  color: var(--ink);
  font: inherit;
  font-size: 15px;
  resize: none;
}

.textarea:focus {
  outline: none;
  border-color: var(--line);
}

.counter {
  align-self: flex-end;
  color: var(--muted);
  font-size: 12px;
}

.card {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 18px;
  border-radius: var(--r-lg);
  background: linear-gradient(150deg, #262626 0%, #121212 60%, #1c1c1c 100%);
  border: 1px solid rgb(255 255 255 / 14%);
}

.cardBrand {
  font-size: 12px;
  letter-spacing: 0.14em;
  color: var(--ink-soft);
}

.cardTitle {
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.01em;
}

.cardMessage {
  font-size: 14px;
  font-style: italic;
  color: var(--ink-soft);
  overflow-wrap: anywhere;
}

.lead {
  margin: 12px 2px 0;
  color: var(--ink-soft);
  font-size: 15px;
  line-height: 1.4;
}

.linkRow {
  margin-top: 12px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 8px 8px 14px;
  background: var(--surface-sunken);
  border-radius: var(--r-md);
}

.link {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: var(--mono);
  font-size: 13px;
  color: var(--ink);
}

.copy {
  flex: none;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: var(--r-sm);
  background: var(--surface);
  color: var(--ink);
  cursor: pointer;
}

.item {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  background: var(--surface);
  border: 1px solid var(--card-border);
  border-radius: var(--r-lg);
}

.itemHead {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.itemTitle {
  font-size: 17px;
  font-weight: 600;
}

.itemMeta {
  color: var(--muted);
  font-size: 13px;
}

.itemRecipient {
  color: var(--ink-soft);
  font-size: 14px;
}

.badge {
  flex: none;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
}

.badgePending {
  background: var(--warn-wash);
  color: var(--warn);
}

.badgeDone {
  background: var(--ok-wash);
  color: var(--ok);
}

.badgeOff {
  background: var(--danger-wash);
  color: var(--danger);
}

.actions {
  display: flex;
  gap: 8px;
}

.actions > * {
  flex: 1 1 0;
}
